import { forwardRef } from 'react';
import { HighlightedTextMarkerProps } from './HighlightedTextMarker.props';
import { StyledHighlightedTextMarker } from './HighlightedTextMarker.styles';

const HighlightedTextMarker = forwardRef<HTMLElement, HighlightedTextMarkerProps>(
  ({ htmlPart, isCurrentHighlight }, ref) => (
    <StyledHighlightedTextMarker
      ref={ref}
      // we can use dangerouslySetInnerHTML because the html is a curated list of supported tags generated internally
      dangerouslySetInnerHTML={{ __html: htmlPart.text }}
      isCurrentHighlight={isCurrentHighlight}
    />
  )
);

export default HighlightedTextMarker;
